import {Link} from 'react-router-dom';
import {useParams} from 'react-router-dom';
import {useState,useEffect} from 'react';
import axios from "axios";
import {baseUrl, userLocation, ipAddress, userName, formatDateTime} from '../Univ.js'
function HrmsMenu(){
    return (
        <section className="container mt-4">
            <div className="row nurseInpatient">
                <div className='col-md-12 col-12'>
                    <div className="row">
                    <div className="col-md-12 company-info">
                    <div className="panel panel-primary">
                    <div className="panel-heading">
                    <h4 className="panel-title" >HRMS</h4>
                    </div>
                    </div>
                    </div>
                    </div>

                    <div className="row">
                    <div className="col-md-12 company-info">
                    <div className="btn-group">
                    <a href="/add-designation"><button type="button" className="btn btn"><span >Add Designation</span></button></a></div>
                    <div className="btn-group">
                    <a href="/add-employee"><button type="button" className="btn btn"><span >Add Employee</span></button></a></div>
                    <div className="btn-group">
                    <a href="/emp-list"><button type="button" className="btn btn"><span >Employee List</span></button></a></div>
                    <div className="btn-group">
                    <a href="/salary-list"><button type="button" className="btn btn"><span >Payslip List</span></button></a></div>
                    <div className="btn-group">
                    <a href="/add-shift"><button type="button" className="btn btn"><span >Shift List</span></button></a></div>
                                        <div className="btn-group">
                    <a href="/emp-rooster"><button type="button" className="btn btn"><span >Employee Rooster</span></button></a></div>
                                       <div className="btn-group">
                    <a href="/emp-leave"><button type="button" className="btn btn"><span >Employee Leave</span></button></a></div>
                    </div>
                    </div>


               </div>
            </div>
        </section>
    )
}

export default HrmsMenu;